var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-alert',{attrs:{"type":"info","text":"","outlined":""}},[_vm._v(" These settings are synced throughout the app, no matter where they're set ")]),_c('sn-slider'),_c('batteries-slider'),_c('parallel-port')],1)}
var staticRenderFns = []

export { render, staticRenderFns }